import { ExtendableError } from '@seneca/client-library';

export default class UserSchoolInfoDoesNotExistError extends ExtendableError {
  constructor() {
    super(`School info does not exist for user`);
  }
}
